"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonMixin = require("../../mixins/components/ButtonMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['loading'])
}).withConfig({
  displayName: "StyledButton",
  componentId: "c11n-8-107-0__sc-iv7357-0"
})(["", ""], _ButtonMixin.ButtonMixin);
exports.StyledButton = StyledButton;